var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 6.83333C12.5999 6.83333 12.3333 7.1 12.3333 7.5C12.3333 9.43333 11.3333 11.1667 9.66659 12.1C7.13325 13.5667 3.86659 12.7 2.39992 10.1667C0.933252 7.63333 1.79992 4.36667 4.33325 2.9C6.53325 1.63333 9.19992 2.1 10.8666 3.83333H9.26659C8.86659 3.83333 8.59992 4.1 8.59992 4.5C8.59992 4.9 8.86659 5.16667 9.26659 5.16667H12.2666C12.6666 5.16667 12.9333 4.9 12.9333 4.5V1.5C12.9333 1.1 12.6666 0.833334 12.2666 0.833334C11.8666 0.833334 11.5999 1.1 11.5999 1.5V2.7C10.3333 1.5 8.73325 0.833334 6.99992 0.833334C3.33325 0.833334 0.333252 3.83333 0.333252 7.5C0.333252 11.1667 3.33325 14.1667 6.99992 14.1667C10.6666 14.1667 13.6666 11.1667 13.6666 7.5C13.6666 7.1 13.3999 6.83333 12.9999 6.83333Z",
    fill: "#4B4B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.8426cca609ecd86a7c10515950c21d18.svg";
export { ForwardRef as ReactComponent };